﻿/* 
Object:         NodeSearch
Description:    Logic and events for node search
Used in:        NodeSearch
*/

window.nodesearch = function () {
    
    return {
        
        /*
        * Initialize.
        */
        initialize: function () {
            $("#NodeSearchButtonLoader").hide();

            $("#SearchText").keyup(function (event) {
                if (event.keyCode == '13') {
                    nodesearch.searchAction();
                }
            });
        },

        /*
        * node search action (submit)
        */
        searchAction: function () {
            $("#NodeSearchButtonLoader").show();

            $("#SearchResultNodes").data("kendoGrid").pager.dataSource.page(1);
            $("#SearchResultNodes").data("kendoGrid").dataSource.read();

        },

        /*
        * node search action (submit)
        */
        getAdditionalData: function () {

            return {
                text: $("#SearchText").val()
            };

        },

        /*
         * node search action (submit)
         */
        jumpNode: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get Data Item
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Jump Node
            navigation.jumpNode(dataItem.NodeID);
        },

        /*
        * node search action (submit)
        */
        onDataBound: function () {

            $("#NodeSearchButtonLoader").hide();

        }
    }

}();